import PolicyShell, { Section, SubHead, Bullets } from "@/components/PolicyShell";

export default function ReturnsPage() {
  return (
    <PolicyShell
      testId="returns-page"
      overline="BOSCAGE Elegance"
      title="Returns & Exchanges Policy"
      contact="hello@boscage.com  ·  www.boscage.com"
      lastUpdated="BOSCAGE Elegance — Premium Leather Jackets & Apparel — United States. This policy is subject to change without prior notice. Please visit our website for the latest version."
    >
      <p>
        At BOSCAGE Elegance, we take immense pride in the craftsmanship and quality of our products. However, if you
        are not entirely satisfied with your purchase, we are here to help. We offer a straightforward 14-Day Return
        and Exchange Window to ensure your complete peace of mind.
      </p>

      <p className="overline">14-DAY RETURN &amp; EXCHANGE WINDOW</p>

      <Section title="1. Return Eligibility & Conditions">
        <p>To be eligible for a full refund or exchange, your return must meet ALL of the following criteria:</p>
        <Bullets
          items={[
            "Timeframe: Request must be initiated within 14 days from the date of delivery.",
            "Condition: Item must be unused, unworn, unwashed, and in the exact pristine condition received. Leather jackets must show no signs of wear, creasing, or scratches.",
            "Packaging: All original tags, labels, and packaging must be intact and included.",
            "Non-Returnable Items: Personalized, bespoke, or custom-fitted items are strictly non-returnable and non-refundable — unless they arrive damaged or faulty.",
          ]}
        />
      </Section>

      <Section title="2. Return Shipping Costs">
        <SubHead>Change of Mind / Wrong Size</SubHead>
        <p>The customer is responsible for covering the return shipping cost.</p>
        <SubHead>Faulty or Mis-described Item</SubHead>
        <p>BOSCAGE covers the complete return shipping cost and provides a pre-paid shipping label.</p>
      </Section>

      <Section title="3. How to Initiate a Return or Exchange">
        <p>We have made our return process simple and hassle-free:</p>

        <SubHead>Step 1 — Submit a Request</SubHead>
        <p>
          Email our dedicated support team at hello@boscage.com with your Order Number, reason for return/exchange,
          and clear product photos. You may also use our online Return Portal.
        </p>

        <SubHead>Step 2 — Receive Your RL Number</SubHead>
        <p>
          Once approved, our team will issue a unique Return Label (RL) number along with detailed shipping
          instructions. Returns sent without an authorized RL number will not be accepted.
        </p>

        <SubHead>Step 3 — Pack &amp; Ship</SubHead>
        <p>
          Securely pack the item in its original packaging, include the packing slip, and ship it to the address
          provided by our support team.
        </p>
      </Section>

      <Section title="4. The Exchange Process">
        <p>
          Ordered the wrong size or color? No problem. Once you initiate an exchange through our portal and ship the
          original item back, we will reserve your requested replacement item. The new item will be dispatched
          immediately after we receive and inspect the original product.
        </p>
      </Section>

      <Section title="5. Returnless Refunds & Resolutions">
        <p>
          To provide a seamless experience, BOSCAGE Elegance occasionally utilizes a &ldquo;Returnless
          Resolution&rdquo; for specific situations (such as minor sizing issues on basic apparel). At the sole
          discretion of our Customer Support team, we may issue a full refund, partial refund, or store credit without
          requiring you to ship the item back. You will be notified via email if your request qualifies.
        </p>
      </Section>

      <Section title="6. Refund Processing Timeline">
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm" data-testid="refund-timeline-table">
            <thead className="text-[#c9a84c]">
              <tr className="border-b border-[#000000]/15">
                <th className="py-3 pr-3 font-medium uppercase tracking-[0.18em] text-[11px]">Step</th>
                <th className="py-3 pr-3 font-medium uppercase tracking-[0.18em] text-[11px]">Action</th>
                <th className="py-3 font-medium uppercase tracking-[0.18em] text-[11px]">Timeframe</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-[#ffffff]/10">
              <tr>
                <td className="py-3 pr-3">1</td>
                <td className="py-3 pr-3">QA Inspection upon receipt of return</td>
                <td className="py-3">Within 2 business days</td>
              </tr>
              <tr>
                <td className="py-3 pr-3">2</td>
                <td className="py-3 pr-3">Refund processed to original payment method</td>
                <td className="py-3">After inspection approval</td>
              </tr>
              <tr>
                <td className="py-3 pr-3">3</td>
                <td className="py-3 pr-3">Funds reflect in your bank / credit card</td>
                <td className="py-3">5–7 business days</td>
              </tr>
            </tbody>
          </table>
        </div>
        <p className="text-sm text-[#000000]/65 italic">
          Questions? We&apos;re here to help. hello@boscage.com | www.boscage.com
        </p>
      </Section>
    </PolicyShell>
  );
}
